var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailBlueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33301 4L5.94169 6.61131C7.64074 7.574 8.35861 7.574 10.0577 6.61131L14.6663 4",
    stroke: "#0464B2",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.34352 8.98373C1.3871 11.0275 1.40889 12.0493 2.16298 12.8063C2.91706 13.5632 3.96656 13.5895 6.06556 13.6423C7.35921 13.6748 8.64014 13.6748 9.93381 13.6423C12.0328 13.5895 13.0823 13.5632 13.8364 12.8063C14.5905 12.0493 14.6123 11.0275 14.6558 8.98373C14.6699 8.3266 14.6699 7.6734 14.6558 7.01627C14.6123 4.97257 14.5905 3.95073 13.8364 3.19377C13.0823 2.43682 12.0328 2.41045 9.93381 2.35771C8.64014 2.32521 7.35921 2.32521 6.06555 2.35771C3.96656 2.41044 2.91706 2.43681 2.16297 3.19377C1.40889 3.95072 1.3871 4.97257 1.34351 7.01627C1.3295 7.6734 1.32951 8.3266 1.34352 8.98373Z",
    stroke: "#0464B2",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailBlueIcon);
export default __webpack_public_path__ + "static/media/mailBlueIcon.729cd2b1fd01b3df3b4b9c7a6a473158.svg";
export { ForwardRef as ReactComponent };